import React, { useState } from 'react';
import { Input } from '../../../../components/Input/Input';

const euVatMapping: { [key: string]: string } = {
  AT: 'ATU12345678',
  BE: 'BE0123456789',
  BG: 'BG123456789',
  HR: 'HR12345678901',
  CY: 'CY12345678X',
  CZ: 'CZ12345678',
  DK: 'DK12345678',
  EE: 'EE123456789',
  FI: 'FI12345678',
  FR: 'FRXX123456789',
  DE: 'DE123456789',
  GR: 'EL123456789',
  HU: 'HU12345678',
  IE: 'IE1234567X',
  IT: 'IT12345678901',
  LV: 'LV12345678901',
  LT: 'LT123456789',
  LU: 'LU12345678',
  MT: 'MT12345678',
  NL: 'NL123456789B01',
  PL: 'PL1234567890',
  PT: 'PT123456789',
  RO: 'RO1234567890',
  SK: 'SK1234567890',
  SI: 'SI12345678',
  ES: 'ESX1234567X',
  SE: 'SE123456789701'
};

export interface EUVatNumberProps {
  disabled?: boolean;
  countryCode?: string;
  euVatNumber?: string;
  euVatNumberChanged?: (vatNumber: string) => void;
  isEUVatNumberRequired?: (isEUVatNumberRequired: boolean) => void;
}

export function EUVatNumber(props: EUVatNumberProps) {
  const [vatID, setVatID] = useState<string>(props.euVatNumber || '');

  const isRequired = shouldAskForVatNumber(props.countryCode || '');

  function getExampleVatNumberForCountryWithCode(countryCode: string): string {
    return euVatMapping[countryCode.toUpperCase()];
  }

  function shouldAskForVatNumber(countryCode: string): boolean {
    return !!getExampleVatNumberForCountryWithCode(countryCode.toUpperCase());
  }

  if (!isRequired && !props.euVatNumber) {
    return null;
  }

  props.isEUVatNumberRequired && props.isEUVatNumberRequired(isRequired);

  return (
    <>
      <Input
        id="vatId"
        disabled={props.disabled}
        onChange={(event) => {
          setVatID(event.target.value.toUpperCase());

          props.euVatNumberChanged && props.euVatNumberChanged(event.target.value.toUpperCase());
        }}
        required
        value={vatID}
        placeholder={getExampleVatNumberForCountryWithCode(props.countryCode?.toUpperCase() || '')}
        pattern="^[A-Z0-9]+$"
        label="European VAT Number"
        type="text"></Input>
    </>
  );
}
